export const AddRemClass = (addRemFlag: boolean, targetSelector: string, classname: string) => {
	//add remove the class based on @param addRemFlag
	const targetEle = document.querySelector(targetSelector) as HTMLElement;
	addRemFlag && targetEle ? (targetEle.className += " " + classname) : targetEle && targetEle.classList.remove(classname);
};

//based on input value send the class name
// > 0 -> pos
// < 0 -> neg
export const PLCls = (num: string | number): string => {
	//convert to number if the num is in string format
	const convertedVal: number = typeof num === "string" ? parseFloat(num) : num;
	return convertedVal > 0 ? " pos" : convertedVal < 0 ? " neg" : "";
};
